import React, { useEffect, useRef, useState } from 'react';
interface NearViewportProps {
  /** Rendered once the placeholder scrolls within `margin` of the viewport. */
  children: React.ReactNode;
  /** Shown until then — should match the final content's size. */
  placeholder: React.ReactNode;
  /** How far ahead of the viewport to start loading, e.g. '400px'. */
  margin?: string;
  className?: string;
}

/**
 * Defers mounting heavy content (maps, embeds) until the visitor scrolls
 * near it, so its code and network requests don't compete with first paint.
 */
export function NearViewport({
  children,
  placeholder,
  margin = '400px',
  className
}: NearViewportProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node || visible) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    }, {
      rootMargin: margin
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [margin, visible]);
  return <div ref={ref} className={className} data-id="element-3351" data-mp="1b4tm5bhh7u4c">
      {visible ? children : placeholder}
    </div>;
}